/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { of } from "rxjs";
import { MyInjector } from "@src/app/app.module";
import { Unit } from "@src/app/model/unit";
import { ActionColor } from "@src/app/shared/form/form.component";
import { UnitService } from "@src/app/modules/unit/unit.service";
import { IFormAction } from "@src/app/shared/form/form.component";
import { CDSData, ConfirmDialogService } from "@src/app/shared/dialogs/confirmDialog";
import { MAIL_STATUS } from "@src/app/model/person";


export class StatementPDFAction implements IFormAction {
    name = $localize`Print PDF Statement`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'picture_as_pdf';
    approvalNeeded = false;
    disabled = false;
    approvalText = 'Produce a PDF copy';
    tipText: string = $localize `Print a PDF statement of all transactions. You can produce the statement just for this unit, or for all units belonging to the same owner.`;
    unit: Unit;

    unitSvc = MyInjector.instance.get(UnitService)
    cds = MyInjector.instance.get(ConfirmDialogService);

    action() {
        let msg2 = ''
        if (this.unit.owner.mailStatus !== MAIL_STATUS.ok) {
            msg2 = $localize `Warning ${this.unit.owner?.fullName} has mail status [${MAIL_STATUS.getDescription(this.unit.owner.mailStatus)}] you will not be able to send them an email`
        }
    
        const title = $localize`Generate PDF Statement PDF for ${this.unit.owner?.fullName}`;
        const msg = $localize `Generate a statement with all transactions recorded during ${this.unit.owner?.fullName}'s ownership of this unit. 
        ${msg2}
        `;
        const choice = {
            title, msg, options: [
                { name: $localize`Include ${this.unit.name} only`, action: () => this.unitSvc.getPDF(this.unit, false, false) },
                { name: $localize`All units owned by ${this.unit.owner?.fullName}`, action: () => this.unitSvc.getPDF(this.unit, false, true) },
            ]
        } as CDSData;
        this.cds.openChoice(choice);
        return of(this.unit)
    }

    setup(unit: Unit) {
        this.unit = unit;
        this.show = true;
    }
}
